import dashboard from "./Dashboard";
import utilities from "./Employee";

const menuItems = {
  items: [utilities]
};

export default menuItems;